angular.module('rjmNg.directives').directive "timeInterval", [
  "timeRangeEnums"
  (timeRangeEnums) ->
    restrict: "E"
    templateUrl: "directive.timeInterval.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      inputInterval: "="
      outputInterval: "="
      globalInterval: "=?"
      intervalsToShow: "="
      globalDisabled: "=?"
      displayOnly: "=?"
      changed: "=?"
    controller: [
      () ->
        view = @

        view.ICONS = timeRangeEnums.TIME_INTERVAL_ICONS
        view.TIME_INTERVAL_VALUES = timeRangeEnums.TIME_INTERVAL_VALUES

        view.setTimeInterval = (timeInterval) ->
          if view.displayOnly or (view.globalDisabled and timeInterval is view.TIME_INTERVAL_VALUES.GLOBAL)
            return
          else
            view.outputInterval = timeInterval

        view.checkIfChanged = () ->
          view.changed = view.outputInterval isnt view.inputInterval

        view.getIcon = (timeInterval) ->
          return if timeInterval is view.TIME_INTERVAL_VALUES.GLOBAL then view.ICONS[view.globalInterval] else view.ICONS[timeInterval]

        view.getButtonText = (timeInterval) ->
          return if timeInterval is view.TIME_INTERVAL_VALUES.GLOBAL then "Global (#{view.globalInterval})" else timeInterval

        view.initialize = () ->
          view.outputInterval = view.inputInterval
          view.checkIfChanged()

        view.$onInit = () ->
          view.globalDisabled ?= false
          view.globalInterval ?= view.inputInterval
          view.displayOnly ?= false
          view.initialize()

        view
    ]
    link: (scope, element, attr, view) ->
      scope.$watch 'view.outputInterval', view.checkIfChanged, true
      scope.$watch 'view.inputInterval', view.initialize, true
      scope.$on("initializeInterval", view.initialize)
]
